import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-body px-10 px-lg-20 pb-10" }
const _hoisted_2 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-5 col-md-6 d-flex align-items-center justifty-content-center" }
const _hoisted_5 = {
  class: "nav bg-light rounded-pill px-3 py-2 mb-15 w-225px mx-auto",
  "data-kt-buttons": "true",
  "data-kt-initialized": "1",
  style: {"max-width":"225px"}
}
const _hoisted_6 = { class: "mb-15 d-flex flex-column justify-content-center align-items-center" }
const _hoisted_7 = { class: "text-primary fs-3 fw-bold mb-7" }
const _hoisted_8 = { class: "discount-holder" }
const _hoisted_9 = {
  key: 0,
  class: "discount-percentage badge badge-danger text-end"
}
const _hoisted_10 = { class: "fs-5x fw-semibold d-flex flex-row justify-content-center align-items-start lh-sm" }
const _hoisted_11 = {
  key: 0,
  class: "discounted-price me-2 d-flex"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-self-start fs-2 mt-3 align-baseline" }, "$", -1)
const _hoisted_13 = { class: "lh-sm fw-semibold discounted-price-amount" }
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "align-self-start fs-2 mt-3 align-baseline" }, "$", -1)
const _hoisted_16 = { class: "lh-sm fw-semibold" }
const _hoisted_17 = { class: "text-muted fw-bold mb-7 h-100" }
const _hoisted_18 = { class: "d-flex flex-column" }
const _hoisted_19 = ["onClick", "data-kt-indicator", "disabled"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Start", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Redirecting... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "mt-5",
  style: {"font-size":"9pt","font-style":"italic"}
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Note: Starting a subscription requires your ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("a", { href: "/profile/business-details" }, "business details", -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" setup ")
const _hoisted_27 = [
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 2,
  class: "mt-5",
  style: {"font-size":"12pt"}
}
const _hoisted_29 = { class: "table align-middle table-striped gy-7" }
const _hoisted_30 = { class: "card-rounded-start" }
const _hoisted_31 = { class: "fw-bold d-flex align-items-center ps-9 fs-3" }
const _hoisted_32 = { class: "flex-root d-flex justify-content-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x svg-icon-success" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.89557 13.4982L7.79487 11.2651C7.26967 10.7068 6.38251 10.7068 5.85731 11.2651C5.37559 11.7772 5.37559 12.5757 5.85731 13.0878L9.74989 17.2257C10.1448 17.6455 10.8118 17.6455 11.2066 17.2257L18.1427 9.85252C18.6244 9.34044 18.6244 8.54191 18.1427 8.02984C17.6175 7.47154 16.7303 7.47154 16.2051 8.02984L11.061 13.4982C10.7451 13.834 10.2115 13.834 9.89557 13.4982Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x svg-icon-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "7.05025",
      y: "15.5356",
      width: "12",
      height: "2",
      rx: "1",
      transform: "rotate(-45 7.05025 15.5356)",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "8.46447",
      y: "7.05029",
      width: "12",
      height: "2",
      rx: "1",
      transform: "rotate(45 8.46447 7.05029)",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadTable)
      ? (_openBlock(), _createBlock(_component_el_skeleton, {
          key: 0,
          rows: 5,
          animated: ""
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link btn btn-active btn-active-dark fw-bold btn-color-gray-600 py-3 px-5 m-1 rounded-pill", {
                  active: _ctx.getPlanType == 'month',
                }]),
                  "data-kt-plan": "month",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.choosePlanType('month')))
                }, " Monthly ", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link btn btn-active btn-active-dark fw-bold btn-color-gray-600 py-3 px-5 m-1 rounded-pill", {
                  active: _ctx.getPlanType == 'annual',
                }]),
                  "data-kt-plan": "annual",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.choosePlanType('annual')))
                }, " Annually ", 2)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedPlans, (plan) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-lg-3 col-md-3",
                key: plan.code
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$filters.capitalize(plan.code)), 1),
                  _createElementVNode("div", _hoisted_8, [
                    (plan.monthly_discount)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(plan.monthly_discount * 100) + "% Off ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (plan.monthly_discount)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.planType == 'month'
                        ? plan.monthly_price
                        : plan.annual_price), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.planType == 'month'
                        ? _ctx.calculatePrice(
                            plan.monthly_price,
                            plan.monthly_discount
                              ? plan.monthly_discount
                              : 0
                          )
                        : _ctx.calculatePrice(
                            plan.annual_price,
                            plan.annual_discount ? plan.annual_discount : 0
                          )), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.planType == 'month' ? 'Monthly' : 'Annually'), 1),
                  _createElementVNode("div", _hoisted_18, [
                    (plan.monthly_pricing_key)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.checkoutPlan(plan)),
                          class: "btn btn-new-design-primary mx-auto bg-hover-primary align-middle",
                          "data-kt-indicator": _ctx.loadStart ? 'on' : null,
                          disabled: !_ctx.authUser.business_id
                        }, _hoisted_22, 8, _hoisted_19))
                      : _createCommentVNode("", true),
                    (!_ctx.authUser.business_id && plan.monthly_pricing_key)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_23, _hoisted_27))
                      : _createCommentVNode("", true),
                    (plan.has_free_trial === 'yes')
                      ? (_openBlock(), _createElementBlock("small", _hoisted_28, _toDisplayString(plan.free_trial_days) + " Days Free Trial ", 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("table", _hoisted_29, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pricingTable, (priceInclusions, key) => {
                return (_openBlock(), _createElementBlock("tr", { key: key }, [
                  _createElementVNode("th", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$filters.ucwords(key.replace(/_/g, ' '))), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceInclusions, (priceInclusion, index) => {
                    return (_openBlock(), _createElementBlock("td", { key: index }, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["h-40px w-40px d-flex flex-center", priceInclusion ? 'd-block' : 'd-none'])
                        }, _hoisted_34, 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(["h-40px w-40px d-flex flex-center", !priceInclusion ? 'd-block' : 'd-none'])
                        }, _hoisted_36, 2)
                      ])
                    ]))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ]))
  ]))
}